import './enter-brand-page-loading.css';

interface MotionDoorLogoProps {
    /** Logo height in pixels. */
    size: number;
    /** Whether to continuously animate the brand gradient. */
    loop?: boolean;
    /** Optional test identifier for the outer mark. */
    testId?: string;
}

/** Enter 门形品牌标识，可按场景选择静态展示或持续流动。 */
export function MotionDoorLogo({
    size,
    loop = true,
    testId = 'enter-brand-loading-logo',
}: MotionDoorLogoProps) {
    const scale = size / 16;

    return (
        <span
            aria-hidden="true"
            className="relative flex shrink-0 items-center justify-center"
            data-testid={testId}
            style={{ width: size, height: size }}
        >
            <span
                className="enter-brand-door-logo-shape relative block h-4 w-[13.6px] shrink-0 overflow-hidden"
                style={{ transform: `scale(${scale})` }}
            >
                {loop ? (
                    <span className="enter-brand-door-logo-layer enter-brand-door-logo-layer-looping" />
                ) : null}
            </span>
        </span>
    );
}
